module.exports = __webpack_public_path__ + "img/futuris-logo-white.097e5723.svg";